import { render } from "./InspectionImageCamera.vue?vue&type=template&id=9adeefe6&scoped=true"
import script from "./InspectionImageCamera.vue?vue&type=script&lang=js"
export * from "./InspectionImageCamera.vue?vue&type=script&lang=js"

import "./InspectionImageCamera.vue?vue&type=style&index=0&id=9adeefe6&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9adeefe6"]])

export default __exports__